import {JSONSchema4} from 'json-schema';
/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface BulkUploadStagingDetailsSchemaContract {
  bulk_uploads: {
    id: number;
    created_at: string;
    updated_at: string;
    file_name: null | string;
    error_file_name: null | string;
    type: number;
    status: number | null;
    by_people_id: number | null;
    organization_id: number | null;
    number_of_rows_with_error: null | number;
    total_number_of_rows: null | number;
    file_summary: null | {
      [k: string]: unknown;
    };
    input_config: null | {
      payrollMonth?: string | null;
      effectiveMonth?: string | null;
      [k: string]: unknown;
    };
    validation_started_at: null | string;
    validation_finished_at: null | string;
    execution_started_at: null | string;
    execution_finished_at: null | string;
    errors: string[] | null;
    uploaded_file_url: null | string;
    error_file_url: null | string;
    [k: string]: unknown;
  };
  bulk_uploads_staging: {
    current_page: number;
    data: {
      id: number;
      created_at?: string;
      updated_at?: string;
      organization_id?: number;
      people_id?: number | null;
      bulk_uploads_id?: number;
      status?: number;
      file_row?: {
        reasonForRequest?: string | null;
        paymentStatus?: string | null;
        interestType?: string | null;
        interestRate?: string | null;
        perquisiteRate?: string | null;
        repaymentTenure?: string | null;
        emiStartsFrom?: string | null;
        recoveryStartFrom?: string | null;
        loanCategoryId?: number | null;
        loanCategoryName?: string | null;
        peopleOrganizationId?: number | null;
        rowNumber?: number | null;
        sheetName?: string | null;
        sheetNumber?: number | null;
        email?: string | null;
        name?: string | null;
        employeeId?: string | null;
        ctc?: string | null;
        recurringDeductions?: {
          [k: string]: string | null;
        } | null;
        customFields?: {
          [k: string]: string | null;
        } | null;
        vpfAmount?: string | null;
        perquisites?: {
          [k: string]: {
            total_value?: string | null;
            paid_by_employee?: string | null;
            [k: string]: unknown;
          } | null;
        } | null;
        flexiBenefits?: {
          [k: string]: {
            amount?: string | null;
            status?: string | null;
            [k: string]: unknown;
          } | null;
        } | null;
        oldCtc?: string | null;
        employee_email?: string | null;
        payable_days?: number | null;
        gross_salary?: number | null;
        employee_pf?: number | null;
        employee_vpf?: number | null;
        employee_esic?: number | null;
        employee_lwf?: number | null;
        professional_tax?: number | null;
        tds?: number | null;
        total_deductions_b?: number | null;
        net_pay?: number | null;
        employer_pf?: number | null;
        pf_admin_edli_charges?: number | null;
        employer_esic?: number | null;
        employer_lwf?: number | null;
        deductions?: {
          [k: string]: string | number | null;
        } | null;
        leave_encashment?: number | null;
        gratuity?: number | null;
        newCtc?: string | null;
        arrearMonth?: string | null;
        arrearApplicable?: boolean | null;
        arrearAmount?: number | null;
        arrearsBreakdown?:
          | {
              name?: string | null;
              amount?: number | null;
              [k: string]: unknown;
            }[]
          | null;
        earnings?: {
          Basic?: number | null;
          "Dearness Allowance"?: number | null;
          "House Rent Allowance"?: number | null;
          "Leave & Travel Allowance"?: number | null;
          "Special Allowance"?: number | null;
          [k: string]: unknown;
        } | null;
        flexi_earnings?: {
          [k: string]: string | number | null;
        } | null;
        flexi_deductions?: {
          [k: string]: string | number | null;
        } | null;
        amount?: string | null;
        adhocComponent?: string | null;
        tdsRecoveryOption?: string | null;
        type?: string;
        label?: string | null;
        lopDays?: string | null;
        numberOfOvertimeHours?: number | string | null;
        numberOfOvertimeDays?: number | string | null;
        formulaCardName?: string | null;
        formulaCardId?: string | null;
        unit?: string | null;
        workingHoursPerDay?: number | null;
        dailyEntries?:
          | {
              date?: string | null;
              value?: string | null;
              [k: string]: unknown;
            }[]
          | null;
        dateOfHiring?: string | null;
        location?: string | null;
        officeLocationId?: number | null;
        officeLocationName?: string | null;
        ptEnabled?: string | null;
        ptLocation?: string | null;
        lwfEnabled?: string | null;
        lwfLocation?: string | null;
        designation?: string | null;
        department?: string | null;
        manager?: string | null;
        annualCtc?: string | null;
        pan?: string | null;
        pfStatus?: string | null;
        pfUan?: string | null;
        aadharNumber?: string | null;
        esicStatus?: string | null;
        esicIpNumber?: string | null;
        npsEnabled?: string | null;
        pranNumber?: string | null;
        salaryStructure?: string | null;
        lastWorkingDate?: string | null;
        reasonForDismissal?: string | null;
        salaryPayout?: string | null;
        holdSalaryStartMonth?: string | null;
        personalEmail?: string | null;
        net_pay_on_hold?: number | null;
        numberOfDays?: number | null;
        reimbursement?: string | null;
        action?: string | null;
        advance_salary_emi?: string | null;
        oldStructure?: string | null;
        newStructure?: string | null;
        currentFySalary?: string | null;
        currentFyExemptions?: string | null;
        currentFyTds?: string | null;
        pastTaxableSalary?: string | null;
        pastTds?: string | null;
        phone?: string | null;
        whatsappOptin?: string | null;
        gender?: string | null;
        dob?: string | null;
        bankAccount?: string | null;
        bankIfsc?: string | null;
        optionalUserData?: {
          "Personal Phone Number"?: string | null;
          "Blood Group"?: string | null;
          "Marital Status"?: string | null;
          [k: string]: unknown;
        } | null;
        commonProperties?: {
          employeeName?: string | null;
          email?: string | null;
          employeeId?: string | null;
          error?: string | null | unknown[];
          rowNumber?: number;
          peopleId?: number | null;
          sheetNumber?: number | null;
          [k: string]: unknown;
        };
        [k: string]: unknown;
      };
      bulk_uploads_type?: number;
      [k: string]: unknown;
    }[];
    first_page_url: string | null;
    from: number | null;
    last_page: number | null;
    last_page_url: string | null;
    links: {
      url?: string | null;
      label?: string | null;
      active?: boolean;
      [k: string]: unknown;
    }[];
    next_page_url: string | null;
    path: string;
    per_page: number | null;
    prev_page_url: string | null;
    to: number | null;
    total: number;
    [k: string]: unknown;
  };
  [k: string]: unknown;
}

export default <JSONSchema4>{
  $schema: 'http://json-schema.org/draft-04/schema#',
  type: 'object',
  properties: {
    bulk_uploads: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        created_at: { type: ['string'], format: 'date-time' },
        updated_at: { type: ['string'], format: 'date-time' },
        file_name: { type: ['null', 'string'] },
        error_file_name: { type: ['null', 'string'] },
        type: { type: 'number' },
        status: { type: ['number', 'null'] },
        by_people_id: { type: ['number', 'null'] },
        organization_id: { type: ['number', 'null'] },
        number_of_rows_with_error: { type: ['null', 'number'] },
        total_number_of_rows: { type: ['null', 'number'] },
        file_summary: { type: ['null', 'object'] },
        input_config: {
          type: ['null', 'object'],
          properties: {
            payrollMonth: { type: ['string', 'null'], format: 'date' },
            effectiveMonth: { type: ['string', 'null'], format: 'date' },
          },
        },
        validation_started_at: { type: ['null', 'string'], format: 'date-time' },
        validation_finished_at: { type: ['null', 'string'], format: 'date-time' },
        execution_started_at: { type: ['null', 'string'], format: 'date-time' },
        execution_finished_at: { type: ['null', 'string'], format: 'date-time' },
        errors: { type: ['array', 'null'], items: { type: 'string' } },
        uploaded_file_url: { type: ['null', 'string'] },
        error_file_url: { type: ['null', 'string'] },
      },
      required: [
        'id',
        'created_at',
        'updated_at',
        'file_name',
        'error_file_name',
        'type',
        'status',
        'by_people_id',
        'organization_id',
        'number_of_rows_with_error',
        'total_number_of_rows',
        'file_summary',
        'input_config',
        'validation_started_at',
        'validation_finished_at',
        'execution_started_at',
        'execution_finished_at',
        'errors',
        'uploaded_file_url',
        'error_file_url',
      ],
    },
    bulk_uploads_staging: {
      type: 'object',
      properties: {
        current_page: { type: 'number' },
        data: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              id: { type: 'number' },
              created_at: { type: 'string', format: 'date-time' },
              updated_at: { type: 'string', format: 'date-time' },
              organization_id: { type: 'number' },
              people_id: { type: ['number', 'null'] },
              bulk_uploads_id: { type: 'number' },
              status: { type: 'number' },
              file_row: {
                type: 'object',
                properties: {
                  reasonForRequest: { type: ['string', 'null'] },
                  paymentStatus: { type: ['string', 'null'] },
                  interestType: { type: ['string', 'null'] },
                  interestRate: { type: ['string', 'null'] },
                  perquisiteRate: { type: ['string', 'null'] },
                  repaymentTenure: { type: ['string', 'null'] },
                  emiStartsFrom: { type: ['string', 'null'] },
                  recoveryStartFrom: { type: ['string', 'null'] },
                  loanCategoryId: { type: ['number', 'null'] },
                  loanCategoryName: { type: ['string', 'null'] },
                  peopleOrganizationId: { type: ['number', 'null'] },
                  rowNumber: { type: ['number', 'null'] },
                  sheetName: { type: ['string', 'null'] },
                  sheetNumber: { type: ['number', 'null'] },
                  email: { type: ['string', 'null'] },
                  name: { type: ['string', 'null'] },
                  employeeId: { type: ['string', 'null'] },
                  ctc: { type: ['string', 'null'] },
                  recurringDeductions: {
                    type: ['object', 'null'],
                    additionalProperties: { type: ['string', 'null'] },
                  },
                  customFields: {
                    type: ['object', 'null'],
                    additionalProperties: { type: ['string', 'null'] },
                  },
                  vpfAmount: { type: ['string', 'null'] },
                  perquisites: {
                    type: ['object', 'null'],
                    additionalProperties: {
                      type: ['object', 'null'],
                      properties: {
                        total_value: { type: ['string', 'null'] },
                        paid_by_employee: { type: ['string', 'null'] },
                      },
                    },
                  },
                  flexiBenefits: {
                    type: ['object', 'null'],
                    additionalProperties: {
                      type: ['object', 'null'],
                      properties: {
                        amount: { type: ['string', 'null'] },
                        status: { type: ['string', 'null'] },
                      },
                    },
                  },
                  oldCtc: { type: ['string', 'null'] },
                  employee_email: { type: ['string', 'null'] },
                  payable_days: { type: ['number', 'null'] },
                  gross_salary: { type: ['number', 'null'] },
                  employee_pf: { type: ['number', 'null'] },
                  employee_vpf: { type: ['number', 'null'] },
                  employee_esic: { type: ['number', 'null'] },
                  employee_lwf: { type: ['number', 'null'] },
                  professional_tax: { type: ['number', 'null'] },
                  tds: { type: ['number', 'null'] },
                  total_deductions_b: { type: ['number', 'null'] },
                  net_pay: { type: ['number', 'null'] },
                  employer_pf: { type: ['number', 'null'] },
                  pf_admin_edli_charges: { type: ['number', 'null'] },
                  employer_esic: { type: ['number', 'null'] },
                  employer_lwf: { type: ['number', 'null'] },
                  deductions: { type: ['object', 'null'], properties: {} },
                  leave_encashment: { type: ['number', 'null'] },
                  gratuity: { type: ['number', 'null'] },
                  newCtc: { type: ['string', 'null'] },
                  arrearMonth: { type: ['string', 'null'] },
                  arrearApplicable: { type: ['boolean', 'null'] },
                  arrearAmount: { type: ['number', 'null'] },
                  arrearsBreakdown: {
                    type: ['array', 'null'],
                    items: {
                      type: 'object',
                      properties: {
                        name: { type: ['string', 'null'] },
                        amount: { type: ['number', 'null'] },
                      },
                    },
                  },
                  earnings: {
                    type: ['object', 'null'],
                    properties: {
                      Basic: { type: ['number', 'null'] },
                      'Dearness Allowance': { type: ['number', 'null'] },
                      'House Rent Allowance': { type: ['number', 'null'] },
                      'Leave & Travel Allowance': { type: ['number', 'null'] },
                      'Special Allowance': { type: ['number', 'null'] },
                    },
                  },
                  flexi_earnings: { type: ['object', 'null'], properties: {} },
                  flexi_deductions: { type: ['object', 'null'], properties: {} },
                  amount: { type: ['string', 'null'] },
                  adhocComponent: { type: ['string', 'null'] },
                  tdsRecoveryOption: { type: ['string', 'null'] },
                  type: { type: 'string' },
                  label: { type: ['string', 'null'] },
                  lopDays: { type: ['string', 'null'] },
                  numberOfOvertimeHours: { type: ['number', 'string', 'null'] },
                  numberOfOvertimeDays: { type: ['number', 'string', 'null'] },
                  formulaCardName: { type: ['string', 'null'] },
                  formulaCardId: { type: ['string', 'null'] },
                  unit: { type: ['string', 'null'] },
                  workingHoursPerDay: { type: ['number', 'null'] },
                  dailyEntries: {
                    type: ['array', 'null'],
                    items: {
                      type: 'object',
                      properties: {
                        date: { type: ['string', 'null'] },
                        value: { type: ['string', 'null'] },
                      },
                    },
                  },
                  dateOfHiring: { type: ['string', 'null'] },
                  location: { type: ['string', 'null'] },
                  officeLocationId: { type: ['number', 'null'] },
                  officeLocationName: { type: ['string', 'null'] },
                  ptEnabled: { type: ['string', 'null'] },
                  ptLocation: { type: ['string', 'null'] },
                  lwfEnabled: { type: ['string', 'null'] },
                  lwfLocation: { type: ['string', 'null'] },
                  designation: { type: ['string', 'null'] },
                  department: { type: ['string', 'null'] },
                  salaryStructure: { type: ['string', 'null'] },
                  manager: { type: ['string', 'null'] },
                  annualCtc: { type: ['string', 'null'] },
                  pan: { type: ['string', 'null'] },
                  pfStatus: { type: ['string', 'null'] },
                  pfUan: { type: ['string', 'null'] },
                  aadharNumber: { type: ['string', 'null'] },
                  esicStatus: { type: ['string', 'null'] },
                  esicIpNumber: { type: ['string', 'null'] },
                  npsEnabled: { type: ['string', 'null'] },
                  pranNumber: { type: ['string', 'null'] },
                  currentFySalary: { type: ['string', 'null'] },
                  currentFyExemptions: { type: ['string', 'null'] },
                  currentFyTds: { type: ['string', 'null'] },
                  pastTaxableSalary: { type: ['string', 'null'] },
                  pastTds: { type: ['string', 'null'] },
                  phone: { type: ['string', 'null'] },
                  whatsappOptin: { type: ['string', 'null'] },
                  gender: { type: ['string', 'null'] },
                  dob: { type: ['string', 'null'] },
                  bankAccount: { type: ['string', 'null'] },
                  bankIfsc: { type: ['string', 'null'] },
                  optionalUserData: {
                    type: ['object', 'null'],
                    properties: {
                      'Personal Phone Number': { type: ['string', 'null'] },
                      'Blood Group': { type: ['string', 'null'] },
                      'Marital Status': { type: ['string', 'null'] },
                    },
                  },
                  commonProperties: {
                    type: 'object',
                    properties: {
                      employeeName: { type: ['string', 'null'] },
                      email: { type: ['string', 'null'] },
                      employeeId: { type: ['string', 'null'] },
                      error: { type: ['string', 'null', 'array'] },
                      rowNumber: { type: 'number' },
                      peopleId: { type: ['number', 'null'] },
                      sheetNumber: { type: ['number', 'null'] },
                    },
                  },
                },
              },
              bulk_uploads_type: { type: 'number' },
            },
            required: ['id'],
          },
        },
        first_page_url: { type: ['string', 'null'] },
        from: { type: ['number', 'null'] },
        last_page: { type: ['number', 'null'] },
        last_page_url: { type: ['string', 'null'] },
        links: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              url: { type: ['string', 'null'] },
              label: { type: ['string', 'null'] },
              active: { type: 'boolean' },
            },
          },
        },
        next_page_url: { type: ['string', 'null'] },
        path: { type: 'string' },
        per_page: { type: ['number', 'null'] },
        prev_page_url: { type: ['string', 'null'] },
        to: { type: ['number', 'null'] },
        total: { type: 'number' },
      },
      required: [
        'current_page',
        'data',
        'first_page_url',
        'from',
        'last_page',
        'last_page_url',
        'links',
        'next_page_url',
        'path',
        'per_page',
        'prev_page_url',
        'to',
        'total',
      ],
    },
  },
  required: ['bulk_uploads', 'bulk_uploads_staging'],
};
